import React from "react";
import { Box, Grid } from "@mui/material";
import "../CmSearchSuggestionQAPair/CmSearchSuggestionsQAPair.Styles.css";
import { Tag } from "antd";
import { replaceContentEditableText } from "../../utils";
import RatingComponent from "../RatingComponentCM/RatingComponent";
import { useSelector } from "react-redux";
import RatingComponentGenAi from "../RatingComponentGenAi/RatingComponentGenAi";
export default function GenAiAnswerComponent(props) {
	const searchSuggestionReducer = useSelector((state) => state.searchSuggestionsCM)
	return (
		<>
			<Grid container>
				<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
					<div className="suggestionContainer">
						<div className="headingContainer">
							<Tag color={'#1e93d2'} style={{ fontFamily: 'inherit', backgroundColor: '#1e93d2', color: '#fff',marginLeft:'5px' }}>GenAI Answer</Tag>
						</div>
						<Grid container>
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12} padding={1}>
								<Box sx={{
									fontWeight: '300',
									fontSize: '14px',
									backgroundColor: '#f6f6f6',
									padding: '10px'
								}}>
									<div dangerouslySetInnerHTML={{
										__html: replaceContentEditableText(props.data),
									}}></div>
								</Box>
							</Grid>
						</Grid>
						<Grid container justifyContent={"flex-end"}>
						<Grid item>
							<RatingComponentGenAi rating={searchSuggestionReducer.genAIOverallRating} />
						</Grid>
						</Grid>
					</div>
				</Grid>
			</Grid>
		</>
	)
}